// Ship the canonical panel with the app. A loopback override remains for UI work.
function panelUrl(): string {
  const override =
    import.meta.env.DEV && import.meta.env.VITE_SURROUNDINGS_PREVIEW_URL
  const url = new URL(
    override || `${import.meta.env.BASE_URL}surroundings-panel/index.html`,
    window.location.origin,
  )
  if (
    override &&
    (url.protocol !== 'http:' ||
      !['127.0.0.1', 'localhost', '[::1]'].includes(url.hostname) ||
      url.username ||
      url.password)
  ) {
    throw new Error('Surroundings UI preview requires a local HTTP origin')
  }
  url.searchParams.set('embedded', '1')
  url.searchParams.set(
    'theme',
    document.documentElement.classList.contains('dark') ? 'dark' : 'light',
  )
  return url.href
}

export const surroundingsPreviewUrl = panelUrl()
